<template>
  <div>
    <div v-if="formLocation === extraInfoLocation" class="required row mx-0">
      <div class="col-6 px-0 text-left">
        <span class="star">*</span>Required to run carrier quotes.
      </div>

      <div v-if="showPropertyDetailsLink" class="col-6 px-0 text-right">
        <google-locate-button :pageData="pageData"></google-locate-button>
      </div>

      <hr/>
    </div>

    <div
      v-for="(info, key) in formInfo" :key="key"
      v-if="isContentAvailable(info)"
      class="d-flex justify-content-center mx-auto mb-1">
      <div class="alert alert-primary my-0 py-2 w-50" role="alert">
        <div class="row no-gutters">
          <div class="d-inline-block pr-2 my-auto">
            <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
          </div>
          <div class="col d-inline-block my-auto smaller-font-content" v-html="infoContent(info)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleLocateButton from '@/components/presentational/widgets/GoogleLocateButton';

export default {
  props: ['pageData', 'formLocation'],
  data() {
    return {
      extraInfoLocation: 'formtop', // TODO: Use config values
    };
  },
  components: {
    GoogleLocateButton,
  },
  computed: {
    showPropertyDetailsLink() {
      return (this.pageData ? this.pageData.showPropertyDetailsLink : false);
    },
    formInfo() {
      return (this.pageData ? this.pageData.blurbs : []);
    },
  },
  methods: {
    infoContent(info) {
      return info.content;
    },
    isContentAvailable(info) {
      return (info && info.location === this.formLocation && info.visible);
    },
  },
};
</script>

<style scoped>
.google-locate-button {
      margin-right: 24px;
    margin-bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/FormInfo.vue?36f4b634